import counterUp from 'counterup2';
import enterView from 'enter-view';

function animateCountup(el) {
  counterUp(el, {
    duration: 1000,
  });
}

function playAnimation(root) {
  const countupElements = [...root.querySelectorAll('[data-countup]')];

  countupElements.length &&
    enterView({
      selector: countupElements,
      offset: 0.25,
      enter: animateCountup,
      once: true,
    });
}

export function init() {
  playAnimation(document);

  $(window).on('countup.reset', (e, element) => {
    playAnimation(element);
  });
}
